
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"keymapModalTitle":"Tastaturkürzel","info":"Aktuell verfügbare Tastaturkürzel sind farbig hervorgehoben. Allgemeine Tastaturkürzel sind im jeweiligen Kontext immer verfügbar."},"en":{"keymapModalTitle":"Keyboard shortcuts","info":"Currently active hotkeys are highlighted. Common keyboard shortcuts are always active within their respective context."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();